// extracted by mini-css-extract-plugin
module.exports = {"baseFilterBox":"BaseFilterBox_baseFilterBox_JXLDo","baseFilterBox__btn":"BaseFilterBox_baseFilterBox__btn_3glfO"};